import MyBreadcrumb from './breadcrumb.vue';

MyBreadcrumb.install = function(Vue){
  Vue.component('MyBreadcrumb', MyBreadcrumb);
};

export default MyBreadcrumb;